//Generated File 
export default class EditAuthority{
	static readonly Commit = `Commit`;
	static readonly Disabled = `Disabled`;
	static readonly EditAfterCommit = `EditAfterCommit`;
	static readonly SaveDraft = `SaveDraft`;
}
